module.exports = __webpack_public_path__ + "static/media/boton-descarga-transcripcion-icono-negro.8c1d711f.svg";